import { OneTimePurchase } from './one-time-purchase';
import { Subscription } from './subscription';

export type Asset = Subscription | OneTimePurchase;
